<template>
    <v-container v-if="!isMobile" style="width: 98vmax; max-width: 2500px; position: relative;"
        class="justify-center pa-0">

        <v-container class="ml-0 align-center" fluid style="width: 100%;">
        </v-container>

        <v-navigation-drawer v-model="drawer" app temporary>
            <v-list nav>
                <v-list-item v-for="chat in chats" :key="chat.id"
                    :class="{ 'v-list-item--active': chat.id === selectedChatId }" @click="selectChat(chat.id)">
                    <v-list-item>
                        <v-list-item-title>{{ chat.title }}</v-list-item-title>
                        <v-list-item-subtitle>{{ formatDate(chat.started_at) }}</v-list-item-subtitle>
                    </v-list-item>
                </v-list-item>
                <v-list-item @click="addChat">
                    <v-list-item>
                        <v-icon>mdi-plus-circle-outline</v-icon>
                    </v-list-item>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-container class="ml-0" fluid style="width: 100%;" v-if="loading">
            <v-progress-circular color="#006D94" indeterminate></v-progress-circular>
        </v-container>

        <v-container v-if="!loading" class="d-flex pa-0 justify-center">
            <v-card class="chat-window">
                <v-container class="d-flex flex-row-reverse text-dark-grey text-subtitle-2 ma-0 pa-2" fluid>
                    <v-menu v-model="modelMenu" :close-on-content-click="false" :disabled="deepResearch || use_flowcase_bot || use_company_context_addon">
                        <template v-slot:activator="{ props }">
                            <v-btn class="text-subtitle-2" v-bind="props" append-icon="mdi-chevron-down" variant="text" :disabled="deepResearch || use_flowcase_bot || use_company_context_addon" :class="{ 'is-disabled': deepResearch || use_flowcase_bot || use_company_context_addon }" :aria-disabled="deepResearch || use_flowcase_bot || use_company_context_addon"
                                color="grey">
                                Model: {{ models }}
                            </v-btn>
                        </template>

                        <v-card min-width="300">
                            <v-container fluid>
                                <v-radio-group v-model="models" @change="modelMenu = false">
                                    <v-radio value="Auto Reasoning (GPT-5.2)" class="mt-2">
                                        <template v-slot:label>
                                            <div>
                                                <div>Auto Reasoning (GPT-5.2)</div>
                                                <div class="text-caption grey--text">
                                                    Best for fast, context-rich reasoning.
                                                </div>
                                            </div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="Open Source (GPT-OSS)" class="mt-2">
                                        <template v-slot:label>
                                            <div>
                                                <div>Open Source (GPT-OSS)</div>
                                                <div class="text-caption grey--text">
                                                    Fast and efficient reasoning.
                                                </div>
                                            </div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="Deep Analysis (o3)" class="mt-2">
                                        <template v-slot:label>
                                            <div>
                                                <div>Deep Analysis (o3)</div>
                                                <div class="text-caption grey--text">
                                                    Ideal for detailed, in-depth inquiries.
                                                </div>
                                            </div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="Best knowledge (GPT-4o)" class="mt-2">
                                        <template v-slot:label>
                                            <div>
                                                <div>Best knowledge (GPT-4o)</div>
                                                <div class="text-caption grey--text">
                                                    Best for general knowledge questions.
                                                </div>
                                            </div>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                            </v-container>
                        </v-card>
                    </v-menu>
                </v-container>
                <v-divider></v-divider>
                <v-card-text class="chat-content">
                    <div ref="scrollContainer">
                        <div class="message align-center"
                            :style="{ flexDirection: message.from === 'user' ? 'row-reverse' : 'row' }"
                            v-for="(message, index) in messages" :key="index">
                            <div :class="`bubble message ${message.from === 'user' ? 'user' : 'bot'}`"
                                v-html="message.text">

                            </div>
                        </div>
                    </div>
                    <div v-if="isTyping" class="typing-animation">
                        <span class="typing-text">{{ typingText }}</span>
                    </div>
                    <div class="chat-content-divider mt-2"></div>
                    <div class="bottom"></div>
                </v-card-text>

                <v-card-item class="chat-actions mt-0 justify-start">
                    <v-chip v-if="deepResearch" color="indigo" prepend-icon="mdi-magnify-scan">
                        <template v-slot:prepend>
                            <v-icon color="darkblue" class="ml-1">mdi-magnify-scan</v-icon>
                        </template>

                        <span style="color: darkblue;">Deep Research</span>

                        <template v-slot:append>
                            <v-icon class="ml-2" color="indigo" @click="toggleDeepResearch">
                                mdi-close
                            </v-icon>
                        </template>
                    </v-chip>
                    <v-chip v-if="use_flowcase_bot" color="indigo" prepend-icon="mdi-chart-box-outline">
                        <template v-slot:prepend>
                            <v-icon color="darkblue" class="ml-1">mdi-chart-box-outline</v-icon>
                        </template>

                        <span style="color: darkblue;">References Bot</span>

                        <template v-slot:append>
                            <v-icon class="ml-2" color="indigo" @click="toggleReferenceBot">
                                mdi-close
                            </v-icon>
                        </template>
                    </v-chip>
                    <v-chip v-if="use_company_context_addon" color="indigo" prepend-icon="mdi-link-variant">
                        <template v-slot:prepend>
                            <v-icon color="darkblue" class="ml-1">mdi-link-variant</v-icon>
                        </template>

                        <span style="color: darkblue;">Company Context</span>

                        <template v-slot:append>
                            <v-icon class="ml-2" color="indigo" @click="toggleCompanyContextAddon">
                                mdi-close
                            </v-icon>
                        </template>
                    </v-chip>
                </v-card-item>

                <v-card-actions class="chat-options justify-center align-center pb-0">
                    <v-textarea v-if="!isPrintingText" v-model="input" label="Message" auto-grow rows="1" no-resize
                        append-icon="mdi-send" :append-inner-icon="fileupload ? null : 'mdi-paperclip'"
                        @click:append-inner="onUploadFile" @click:append="sendMessage" @keyup.enter="sendMessage"
                        class="input-field" :disabled="fileupload && !convertingPdfDone">
                        <!-- Plus-Icon mit Menü -->
                        <template v-slot:prepend-inner>
                            <v-menu offset-y>
                                <template v-slot:activator="{ props }">
                                    <v-icon v-bind="props" style="cursor: pointer; margin-right: 8px;">
                                        mdi-plus
                                    </v-icon>
                                </template>
                                <v-card>
                                    <v-card-text>
                                        <v-btn block color="black" variant="outlined" prepend-icon="mdi-magnify-scan"
                                            @click="toggleDeepResearch" size="small">
                                            Deep Research
                                        </v-btn>
                                        <v-btn v-if="has_flowcase_addon" class="mt-2" block color="black" variant="outlined"
                                            prepend-icon="mdi-chart-box-outline" @click="toggleReferenceBot" size="small">
                                            References Bot
                                        </v-btn>
                                        <v-btn class="mt-2" block color="black" variant="outlined"
                                            prepend-icon="mdi-link-variant" @click="toggleCompanyContextAddon" size="small">
                                            Company Context
                                        </v-btn>
                                    </v-card-text>
                                </v-card>
                            </v-menu>

                            <!-- Senkrechter Trennstrich -->
                            <div style="
                        width: 1px;
                        background-color: rgba(0,0,0,0.2);
                        margin-right: 8px;
                        height: 35px;
                        align-self: center;
                        "></div>
                        </template>
                    </v-textarea>

                    <v-text-field v-else v-model="input" label="Message" append-icon="mdi-stop"
                        @click:append="stopTyping" @keyup.enter="sendMessage" class="input-field" />
                </v-card-actions>


                <v-card-item v-if="fileupload || fileerror" class="ma-0 mb-0 ml-4 pa-0 justify-start">
                    <v-chip v-if="fileupload" color="indigo">
                        {{ filename }}
                        <template v-slot:append>
                            <v-icon v-if=convertingPdfDone class="ml-2" @click="onRemoveFile">
                                mdi-trash-can-outline
                            </v-icon>
                            <v-progress-circular v-else indeterminate color="indigo" size="12" class="ml-2"
                                width="1"></v-progress-circular>
                        </template>
                    </v-chip>
                    <v-alert v-if="fileerror" type="error" variant="outlined" class="ma-0 pa-2">
                        {{ fileerror_message }}
                    </v-alert>

                </v-card-item>

                <v-card-subtitle class="text-caption font-weight-thin text-disabled mt-2">This chatbot is powered by AI.
                    The chat will
                    be deleted after
                    this session. Thus, no chat history is available. The chat will not be used for any training
                    purpose.
                </v-card-subtitle>

                <span class="text-caption font-weight-thin text-disabled mt-2 mb-1" style="cursor: pointer;"
                    @click="overlayDisclaimer = !overlayDisclaimer">
                    Disclaimer
                </span>

                <v-overlay v-model="overlayDisclaimer" class="align-center justify-center" contained>
                    <v-card max-width="800" class="mx-auto">
                        <v-card-title class="text-center mt-2">
                            <span class="headline">
                                Disclaimer
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <div class="pa-2 text-left" style="max-height: 300px; overflow-y: auto;">
                                <p class="text-center text-grey">English version below</p>
                                <p class="mt-2"><strong>1. Verwendungszweck und Status</strong></p>
                                <ul>
                                    <li>
                                        Dieser digitale Assistent (Chatbot) wird von HPC bereitgestellt, um
                                        Mitarbeitende bei Recherchen, Ideenfindung und Textbausteinen zu unterstützen.
                                    </li>
                                    <li>
                                        Das System befindet sich in einer Test-/Pilotphase und kann bei Bedarf
                                        eingeschränkt oder abgeschaltet werden.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>2. Teilweise Web-Recherche</strong></p>
                                <ul>
                                    <li>
                                        Um aktuelle Informationen einzuholen, nutzt der Chatbot bei Bedarf Bing Search
                                        innerhalb von Microsoft Azure. Dabei werden nur relevante Teilinhalte des
                                        Prompts
                                        an die Such-API übermittelt.
                                    </li>
                                    <li>
                                        Eine vollständige Weitergabe der gesamten Unterhaltung an die Web-Suche erfolgt
                                        nicht.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>3. Zulässige Eingaben</strong></p>
                                <ul>
                                    <li>
                                        Erlaubt: Interne Projektnamen, Kunden-/Kollegen-Namen, geschäftliche Daten,
                                        soweit für
                                        die Arbeit erforderlich.
                                    </li>
                                    <li>
                                        Bitte meiden: Hochsensible Daten (gemäß DSGVO Art. 9), z. B. Gesundheitsangaben,
                                        politische
                                        oder religiöse Überzeugungen u. Ä. Wenn absolut nötig, klären Sie das vorab mit
                                        Ihrer
                                        Datenschutzabteilung.
                                    </li>
                                    <li>
                                        Achtung bei streng vertraulichen Themen: Geben Sie hier nur das Nötigste ein.
                                        Bei Bedarf
                                        interne Kanäle (z. B. verschlüsselte Mails) nutzen.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>4. Datenschutz & Verarbeitung</strong></p>
                                <ul>
                                    <li>
                                        Keine dauerhafte Speicherung: Eingaben werden nicht in einer HPC-eigenen
                                        Datenbank abgelegt.
                                        Sie verbleiben maximal 30 Tage in Azure-Logs zur Missbrauchsüberwachung.
                                    </li>
                                    <li>
                                        Keine Trainingsnutzung: Die Eingaben dienen nicht dem KI-Modelltraining.
                                        Microsoft/OpenAI hat
                                        darauf keinen Zugriff für Trainingszwecke.
                                    </li>
                                    <li>
                                        DSGVO-Konformität: HPC hat mit Microsoft Azure entsprechende Verträge (DPA) und
                                        richtet sich
                                        nach
                                        dem Prinzip der Datenminimierung.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>5. Haftungsausschluss & Inhaltliche Grenzen</strong></p>
                                <ul>
                                    <li>
                                        Automatisierte Antworten: Der Chatbot generiert Texte mithilfe eines
                                        Sprachmodells und ggf.
                                        externer Webquellen. Diese können fehlerhaft, veraltet oder unvollständig sein.
                                    </li>
                                    <li>
                                        Keine verbindliche Beratung: Alle Ausgaben sind unverbindlich. Für kritische
                                        Entscheidungen
                                        ist eine fachliche Prüfung oder ein menschliches Review erforderlich.
                                    </li>
                                    <li>
                                        Haftung: HPC haftet nicht für Schäden, die aus dem Vertrauen auf Chatbot-Inhalte
                                        entstehen,
                                        soweit gesetzlich zulässig.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>6. Web-Inhalte und Urheberrecht</strong></p>
                                <ul>
                                    <li>
                                        Bei Web-Recherchen können urheberrechtlich geschützte Texte oder Ausschnitte zum
                                        Teil in die
                                        Antwort einfließen.
                                    </li>
                                    <li>
                                        Wir bemühen uns, nur kurze Zitate oder Zusammenfassungen zu liefern. Eine
                                        kommerzielle oder
                                        unrechtmäßige Weiterverwendung liegt in der Verantwortung der Nutzenden.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>7. Security & Missbrauch</strong></p>
                                <ul>
                                    <li>
                                        Alle Datenverbindungen sind abgesichert, dennoch verbleibt ein Restrisiko (z. B.
                                        bei gezielten
                                        Angriffen).
                                    </li>
                                    <li>
                                        Missbrauch: Verstöße gegen geltendes Recht oder interne Firmenvorgaben (z. B.
                                        Eingabe sensibler
                                        Daten ohne Grund, Erzeugen schädlicher Inhalte) sind untersagt. HPC behält sich
                                        vor, Zugriffe
                                        einzuschränken oder zu sperren und ggf. weitere Schritte einzuleiten.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>8. Konformität mit KI-Act und Data Act</strong></p>
                                <ul>
                                    <li>
                                        HPC hat eine interne Risikobeurteilung durchgeführt (siehe interne
                                        Dokumentation) und
                                        berücksichtigt
                                        relevante Vorgaben des KI-Acts (Art. 9) sowie des EU Data Acts.
                                    </li>
                                    <li>
                                        Aktuell keine Einstufung als „High Risk“; sollte sich der Einsatzbereich ändern
                                        (z. B.
                                        Personalentscheidungen,
                                        Finanz- oder Gesundheitsbereich), bedarf es einer erneuten Freigabe durch
                                        Compliance.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>9. Änderungen und Kommunikation</strong></p>
                                <ul>
                                    <li>
                                        HPC kann diesen Disclaimer jederzeit an neue technische, organisatorische oder
                                        rechtliche
                                        Anforderungen
                                        anpassen.
                                    </li>
                                    <li>
                                        Über wesentliche Änderungen werden die Nutzenden informiert (Intranet, E-Mail
                                        o. Ä.).
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>10. Kontakt und Rückfragen</strong></p>
                                <ul>
                                    <li>
                                        Allgemein/Sicherheit: Wir haben einen Datenschutzbeauftragten ernannt.
                                    </li>
                                    <li>
                                        Hamburger Hafen und Logistik Aktiengesellschaft
                                        Konzernbeauftragter für den Datenschutz
                                        Herr Dr. John Maurer
                                        Bei St. Annen 1
                                        20457 Hamburg
                                        Phone: +49 40 74008-0
                                        E-mail: info@hpc-hamburg.de
                                    </li>
                                </ul>

                                <p class="mt-2 mb-4">
                                    Mit der Nutzung dieses Assistenten stimmen Sie den oben genannten Bedingungen zu und
                                    nehmen sie zur
                                    Kenntnis.
                                </p>
                                <v-divider></v-divider>
                                <v-divider></v-divider>
                                <p class="mt-4"><strong>1. Purpose and Status</strong></p>
                                <ul>
                                    <li>
                                        This digital assistant (chatbot) is provided by HPC to support employees in
                                        research, idea
                                        generation, and text modules.
                                    </li>
                                    <li>
                                        The system is in a test/pilot phase and may be restricted or deactivated if
                                        necessary.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>2. Partial Web Search</strong></p>
                                <ul>
                                    <li>
                                        To retrieve up-to-date information, the chatbot uses Bing Search within
                                        Microsoft Azure when
                                        needed. Only relevant parts of the prompt are transmitted to the search API.
                                    </li>
                                    <li>
                                        A complete transmission of the entire conversation to the web search does not
                                        take place.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>3. Permitted Inputs</strong></p>
                                <ul>
                                    <li>
                                        Allowed: Internal project names, customer/colleague names, business data, as far
                                        as required for
                                        work purposes.
                                    </li>
                                    <li>
                                        Please avoid: Highly sensitive data (as per GDPR Art. 9), e.g., health
                                        information, political or
                                        religious beliefs, etc. If absolutely necessary, consult your data protection
                                        department
                                        beforehand.
                                    </li>
                                    <li>
                                        Caution with strictly confidential topics: Only enter what is necessary. Use
                                        internal channels
                                        (e.g., encrypted emails) if needed.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>4. Data Protection & Processing</strong></p>
                                <ul>
                                    <li>
                                        No permanent storage: Inputs are not stored in an HPC-owned database. They
                                        remain in Azure logs
                                        for a maximum of 30 days for abuse monitoring.
                                    </li>
                                    <li>
                                        No training usage: Inputs are not used for AI model training. Microsoft/OpenAI
                                        has no access for
                                        training purposes.
                                    </li>
                                    <li>
                                        GDPR compliance: HPC has appropriate contracts (DPA) with Microsoft Azure and
                                        follows the
                                        principle of data minimization.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>5. Liability Disclaimer & Content Limitations</strong></p>
                                <ul>
                                    <li>
                                        Automated responses: The chatbot generates text using a language model and, if
                                        applicable,
                                        external web sources. These may be incorrect, outdated, or incomplete.
                                    </li>
                                    <li>
                                        No binding advice: All outputs are non-binding. Critical decisions require
                                        expert review or
                                        human verification.
                                    </li>
                                    <li>
                                        Liability: HPC is not liable for damages resulting from reliance on
                                        chatbot-generated content,
                                        to the extent permitted by law.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>6. Web Content and Copyright</strong></p>
                                <ul>
                                    <li>
                                        Web searches may include copyrighted texts or excerpts in responses.
                                    </li>
                                    <li>
                                        We strive to provide only short quotes or summaries. Users are responsible for
                                        any commercial or
                                        unlawful reuse.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>7. Security & Misuse</strong></p>
                                <ul>
                                    <li>
                                        All data connections are secured, but a residual risk remains (e.g., targeted
                                        attacks).
                                    </li>
                                    <li>
                                        Misuse: Violations of applicable laws or internal company policies (e.g.,
                                        entering sensitive
                                        data without justification, generating harmful content) are prohibited. HPC
                                        reserves the right
                                        to restrict or block access and take further action if necessary.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>8. Compliance with AI Act and Data Act</strong></p>
                                <ul>
                                    <li>
                                        HPC has conducted an internal risk assessment (see internal documentation) and
                                        considers
                                        relevant requirements of the AI Act (Art. 9) and the EU Data Act.
                                    </li>
                                    <li>
                                        Currently, no classification as "High Risk"; if the scope changes (e.g.,
                                        personnel decisions,
                                        financial or healthcare applications), a new approval by Compliance is required.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>9. Changes and Communication</strong></p>
                                <ul>
                                    <li>
                                        HPC may adjust this disclaimer at any time to reflect new technical,
                                        organizational, or legal
                                        requirements.
                                    </li>
                                    <li>
                                        Users will be informed of significant changes (Intranet, email, etc.).
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>10. Contact and Inquiries</strong></p>
                                <ul>
                                    <li>
                                        General/Security: We have appointed a data protection officer.
                                    </li>
                                    <li>
                                        Hamburger Hafen und Logistik Aktiengesellschaft
                                        Konzernbeauftragter für den Datenschutz
                                        Herr Dr. John Maurer
                                        Bei St. Annen 1
                                        20457 Hamburg
                                        Phone: +49 40 74008-0
                                        E-mail: info@hpc-hamburg.de
                                    </li>
                                </ul>

                                <p class="mt-2">
                                    By using this assistant, you agree to and acknowledge the above conditions.
                                </p>
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="overlayDisclaimer = false" block>
                                Close
                            </v-btn>
                        </v-card-actions>
                    </v-card>

                </v-overlay>


                <input type="file" ref="fileInput" style="display: none" accept="application/pdf"
                    @change="handleFileUpload" />
            </v-card>
        </v-container>
    </v-container>

    <v-container v-else class="justify-center pa-0">

        <v-container class="ml-0" fluid style="width: 100%;" v-if="loading">
            <v-progress-circular color="#006D94" indeterminate></v-progress-circular>
        </v-container>

        <v-container v-if="!loading" class="d-flex pa-0 justify-center">
            <v-card class="chat-window-mobile">
                <v-container class="d-flex flex-row-reverse text-dark-grey text-subtitle-2 ma-0 pa-2" fluid>
                    <v-menu v-model="modelMenu" :close-on-content-click="false">
                        <template v-slot:activator="{ props }">
                            <v-btn class="text-subtitle-2" v-bind="props" append-icon="mdi-chevron-down" variant="text"
                                color="grey">
                                Model: {{ models }}
                            </v-btn>
                        </template>

                        <v-card min-width="300">
                            <v-container fluid>
                                <v-radio-group v-model="models" @change="modelMenu = false">
                                    <v-radio value="Auto Reasoning (GPT-5.2)" class="mt-2">
                                        <template v-slot:label>
                                            <div>
                                                <div>Auto Reasoning (GPT-5.2)</div>
                                                <div class="text-caption grey--text">
                                                    Best for fast, context-rich reasoning.
                                                </div>
                                            </div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="Open Source (GPT-OSS)" class="mt-2">
                                        <template v-slot:label>
                                            <div>
                                                <div>Open Source (GPT-OSS)</div>
                                                <div class="text-caption grey--text">
                                                    Fast and efficient reasoning.
                                                </div>
                                            </div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="Deep Analysis (o3)" class="mt-2">
                                        <template v-slot:label>
                                            <div>
                                                <div>Deep Analysis (o3)</div>
                                                <div class="text-caption grey--text">
                                                    Ideal for detailed, in-depth inquiries.
                                                </div>
                                            </div>
                                        </template>
                                    </v-radio>
                                    <v-radio value="Best knowledge (GPT-4o)" class="mt-2">
                                        <template v-slot:label>
                                            <div>
                                                <div>Best knowledge (GPT-4o)</div>
                                                <div class="text-caption grey--text">
                                                    Best for general knowledge questions.
                                                </div>
                                            </div>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                            </v-container>
                        </v-card>
                    </v-menu>
                </v-container>
                <v-divider></v-divider>
                <v-card-text class="chat-content">
                    <div ref="scrollContainer">
                        <div class="message align-center"
                            :style="{ flexDirection: message.from === 'user' ? 'row-reverse' : 'row' }"
                            v-for="(message, index) in messages" :key="index">
                            <div :class="`bubble message ${message.from === 'user' ? 'user' : 'bot'}`"
                                v-html="message.text">

                            </div>
                        </div>
                        <div v-if="isTyping" class="typing-animation">
                            <span v-for="(index, i) in 3" :key="index" class="dot"
                                :style="{ animationDelay: `${i * 0.3}s`, backgroundColor: i === 1 ? '#333' : '#000' }"></span>
                        </div>
                        <div class="chat-content-divider mt-2"></div>
                        <div class="bottom"></div>
                    </div>
                </v-card-text>
                <v-card-actions class="chat-actions justify-center align-center pb-0">
                    <v-textarea v-if="!isPrintingText" v-model="input" label="Message" auto-grow rows="1" no-resize
                        append-icon="mdi-send" :append-inner-icon="fileupload ? null : 'mdi-paperclip'"
                        @click:append-inner="onUploadFile" @click:append="sendMessage" @keyup.enter="sendMessage"
                        class="input-field" :disabled="fileupload && !convertingPdfDone" />
                    <v-text-field v-else v-model="input" label="Message" append-icon="mdi-stop"
                        @click:append="stopTyping" @keyup.enter="sendMessage" class="input-field">
                    </v-text-field>
                </v-card-actions>
                <v-card-item v-if="fileupload || fileerror" class="ma-0 mb-4 ml-4 pa-0 justify-start">
                    <v-chip v-if="fileupload" color="indigo">
                        {{ filename }}
                        <template v-slot:append>
                            <v-icon v-if=convertingPdfDone class="ml-2" @click="onRemoveFile">
                                mdi-trash-can-outline
                            </v-icon>
                            <v-progress-circular v-else indeterminate color="indigo" size="12" class="ml-2"
                                width="1"></v-progress-circular>
                        </template>
                    </v-chip>
                    <v-alert v-if="fileerror" type="error" variant="outlined" class="ma-0 pa-2">
                        {{ fileerror_message }}
                    </v-alert>
                </v-card-item>

                <v-card-subtitle class="text-caption font-weight-thin text-disabled ma-2">
                    The chat will be deleted after this session
                </v-card-subtitle>

                <span class="text-caption font-weight-thin text-disabled mt-2 mb-1" style="cursor: pointer;"
                    @click="overlayDisclaimer = !overlayDisclaimer">
                    Disclaimer
                </span>

                <v-overlay v-model="overlayDisclaimer" class="align-center justify-center" contained>
                    <v-card max-width="800" class="mx-auto">
                        <v-card-title class="text-center mt-2">
                            <span class="headline">
                                Disclaimer
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <div class="pa-2 text-left" style="max-height: 300px; overflow-y: auto;">
                                <p class="text-center text-grey">English version below</p>
                                <p class="mt-2"><strong>1. Verwendungszweck und Status</strong></p>
                                <ul>
                                    <li>
                                        Dieser digitale Assistent (Chatbot) wird von HPC bereitgestellt, um
                                        Mitarbeitende bei Recherchen, Ideenfindung und Textbausteinen zu unterstützen.
                                    </li>
                                    <li>
                                        Das System befindet sich in einer Test-/Pilotphase und kann bei Bedarf
                                        eingeschränkt oder abgeschaltet werden.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>2. Teilweise Web-Recherche</strong></p>
                                <ul>
                                    <li>
                                        Um aktuelle Informationen einzuholen, nutzt der Chatbot bei Bedarf Bing Search
                                        innerhalb von Microsoft Azure. Dabei werden nur relevante Teilinhalte des
                                        Prompts
                                        an die Such-API übermittelt.
                                    </li>
                                    <li>
                                        Eine vollständige Weitergabe der gesamten Unterhaltung an die Web-Suche erfolgt
                                        nicht.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>3. Zulässige Eingaben</strong></p>
                                <ul>
                                    <li>
                                        Erlaubt: Interne Projektnamen, Kunden-/Kollegen-Namen, geschäftliche Daten,
                                        soweit für
                                        die Arbeit erforderlich.
                                    </li>
                                    <li>
                                        Bitte meiden: Hochsensible Daten (gemäß DSGVO Art. 9), z. B. Gesundheitsangaben,
                                        politische
                                        oder religiöse Überzeugungen u. Ä. Wenn absolut nötig, klären Sie das vorab mit
                                        Ihrer
                                        Datenschutzabteilung.
                                    </li>
                                    <li>
                                        Achtung bei streng vertraulichen Themen: Geben Sie hier nur das Nötigste ein.
                                        Bei Bedarf
                                        interne Kanäle (z. B. verschlüsselte Mails) nutzen.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>4. Datenschutz & Verarbeitung</strong></p>
                                <ul>
                                    <li>
                                        Keine dauerhafte Speicherung: Eingaben werden nicht in einer HPC-eigenen
                                        Datenbank abgelegt.
                                        Sie verbleiben maximal 30 Tage in Azure-Logs zur Missbrauchsüberwachung.
                                    </li>
                                    <li>
                                        Keine Trainingsnutzung: Die Eingaben dienen nicht dem KI-Modelltraining.
                                        Microsoft/OpenAI hat
                                        darauf keinen Zugriff für Trainingszwecke.
                                    </li>
                                    <li>
                                        DSGVO-Konformität: HPC hat mit Microsoft Azure entsprechende Verträge (DPA) und
                                        richtet sich
                                        nach
                                        dem Prinzip der Datenminimierung.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>5. Haftungsausschluss & Inhaltliche Grenzen</strong></p>
                                <ul>
                                    <li>
                                        Automatisierte Antworten: Der Chatbot generiert Texte mithilfe eines
                                        Sprachmodells und ggf.
                                        externer Webquellen. Diese können fehlerhaft, veraltet oder unvollständig sein.
                                    </li>
                                    <li>
                                        Keine verbindliche Beratung: Alle Ausgaben sind unverbindlich. Für kritische
                                        Entscheidungen
                                        ist eine fachliche Prüfung oder ein menschliches Review erforderlich.
                                    </li>
                                    <li>
                                        Haftung: HPC haftet nicht für Schäden, die aus dem Vertrauen auf Chatbot-Inhalte
                                        entstehen,
                                        soweit gesetzlich zulässig.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>6. Web-Inhalte und Urheberrecht</strong></p>
                                <ul>
                                    <li>
                                        Bei Web-Recherchen können urheberrechtlich geschützte Texte oder Ausschnitte zum
                                        Teil in die
                                        Antwort einfließen.
                                    </li>
                                    <li>
                                        Wir bemühen uns, nur kurze Zitate oder Zusammenfassungen zu liefern. Eine
                                        kommerzielle oder
                                        unrechtmäßige Weiterverwendung liegt in der Verantwortung der Nutzenden.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>7. Security & Missbrauch</strong></p>
                                <ul>
                                    <li>
                                        Alle Datenverbindungen sind abgesichert, dennoch verbleibt ein Restrisiko (z. B.
                                        bei gezielten
                                        Angriffen).
                                    </li>
                                    <li>
                                        Missbrauch: Verstöße gegen geltendes Recht oder interne Firmenvorgaben (z. B.
                                        Eingabe sensibler
                                        Daten ohne Grund, Erzeugen schädlicher Inhalte) sind untersagt. HPC behält sich
                                        vor, Zugriffe
                                        einzuschränken oder zu sperren und ggf. weitere Schritte einzuleiten.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>8. Konformität mit KI-Act und Data Act</strong></p>
                                <ul>
                                    <li>
                                        HPC hat eine interne Risikobeurteilung durchgeführt (siehe interne
                                        Dokumentation) und
                                        berücksichtigt
                                        relevante Vorgaben des KI-Acts (Art. 9) sowie des EU Data Acts.
                                    </li>
                                    <li>
                                        Aktuell keine Einstufung als „High Risk“; sollte sich der Einsatzbereich ändern
                                        (z. B.
                                        Personalentscheidungen,
                                        Finanz- oder Gesundheitsbereich), bedarf es einer erneuten Freigabe durch
                                        Compliance.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>9. Änderungen und Kommunikation</strong></p>
                                <ul>
                                    <li>
                                        HPC kann diesen Disclaimer jederzeit an neue technische, organisatorische oder
                                        rechtliche
                                        Anforderungen
                                        anpassen.
                                    </li>
                                    <li>
                                        Über wesentliche Änderungen werden die Nutzenden informiert (Intranet, E-Mail
                                        o. Ä.).
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>10. Kontakt und Rückfragen</strong></p>
                                <ul>
                                    <li>
                                        Allgemein/Sicherheit: HPC-IT-Support (info@hpc-hamburg.de)
                                    </li>
                                    <li>
                                        Datenschutz: Datenschutzbeauftragte/r bei HPC oder zuständige
                                        Datenschutzaufsichtsbehörde
                                    </li>
                                </ul>

                                <p class="mt-2 mb-4">
                                    Mit der Nutzung dieses Assistenten stimmen Sie den oben genannten Bedingungen zu und
                                    nehmen sie zur
                                    Kenntnis.
                                </p>
                                <v-divider></v-divider>
                                <v-divider></v-divider>
                                <p class="mt-4"><strong>1. Purpose and Status</strong></p>
                                <ul>
                                    <li>
                                        This digital assistant (chatbot) is provided by HPC to support employees in
                                        research, idea
                                        generation, and text modules.
                                    </li>
                                    <li>
                                        The system is in a test/pilot phase and may be restricted or deactivated if
                                        necessary.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>2. Partial Web Search</strong></p>
                                <ul>
                                    <li>
                                        To retrieve up-to-date information, the chatbot uses Bing Search within
                                        Microsoft Azure when
                                        needed. Only relevant parts of the prompt are transmitted to the search API.
                                    </li>
                                    <li>
                                        A complete transmission of the entire conversation to the web search does not
                                        take place.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>3. Permitted Inputs</strong></p>
                                <ul>
                                    <li>
                                        Allowed: Internal project names, customer/colleague names, business data, as far
                                        as required for
                                        work purposes.
                                    </li>
                                    <li>
                                        Please avoid: Highly sensitive data (as per GDPR Art. 9), e.g., health
                                        information, political or
                                        religious beliefs, etc. If absolutely necessary, consult your data protection
                                        department
                                        beforehand.
                                    </li>
                                    <li>
                                        Caution with strictly confidential topics: Only enter what is necessary. Use
                                        internal channels
                                        (e.g., encrypted emails) if needed.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>4. Data Protection & Processing</strong></p>
                                <ul>
                                    <li>
                                        No permanent storage: Inputs are not stored in an HPC-owned database. They
                                        remain in Azure logs
                                        for a maximum of 30 days for abuse monitoring.
                                    </li>
                                    <li>
                                        No training usage: Inputs are not used for AI model training. Microsoft/OpenAI
                                        has no access for
                                        training purposes.
                                    </li>
                                    <li>
                                        GDPR compliance: HPC has appropriate contracts (DPA) with Microsoft Azure and
                                        follows the
                                        principle of data minimization.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>5. Liability Disclaimer & Content Limitations</strong></p>
                                <ul>
                                    <li>
                                        Automated responses: The chatbot generates text using a language model and, if
                                        applicable,
                                        external web sources. These may be incorrect, outdated, or incomplete.
                                    </li>
                                    <li>
                                        No binding advice: All outputs are non-binding. Critical decisions require
                                        expert review or
                                        human verification.
                                    </li>
                                    <li>
                                        Liability: HPC is not liable for damages resulting from reliance on
                                        chatbot-generated content,
                                        to the extent permitted by law.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>6. Web Content and Copyright</strong></p>
                                <ul>
                                    <li>
                                        Web searches may include copyrighted texts or excerpts in responses.
                                    </li>
                                    <li>
                                        We strive to provide only short quotes or summaries. Users are responsible for
                                        any commercial or
                                        unlawful reuse.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>7. Security & Misuse</strong></p>
                                <ul>
                                    <li>
                                        All data connections are secured, but a residual risk remains (e.g., targeted
                                        attacks).
                                    </li>
                                    <li>
                                        Misuse: Violations of applicable laws or internal company policies (e.g.,
                                        entering sensitive
                                        data without justification, generating harmful content) are prohibited. HPC
                                        reserves the right
                                        to restrict or block access and take further action if necessary.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>8. Compliance with AI Act and Data Act</strong></p>
                                <ul>
                                    <li>
                                        HPC has conducted an internal risk assessment (see internal documentation) and
                                        considers
                                        relevant requirements of the AI Act (Art. 9) and the EU Data Act.
                                    </li>
                                    <li>
                                        Currently, no classification as "High Risk"; if the scope changes (e.g.,
                                        personnel decisions,
                                        financial or healthcare applications), a new approval by Compliance is required.
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>9. Changes and Communication</strong></p>
                                <ul>
                                    <li>
                                        HPC may adjust this disclaimer at any time to reflect new technical,
                                        organizational, or legal
                                        requirements.
                                    </li>
                                    <li>
                                        Users will be informed of significant changes (Intranet, email, etc.).
                                    </li>
                                </ul>

                                <p class="mt-2"><strong>10. Contact and Inquiries</strong></p>
                                <ul>
                                    <li>
                                        General/Security: HPC IT Support (info@hpc-hamburg.de)
                                    </li>
                                    <li>
                                        Data Protection: Data Protection Officer at HPC or the relevant data protection
                                        supervisory
                                        authority
                                    </li>
                                </ul>

                                <p class="mt-2">
                                    By using this assistant, you agree to and acknowledge the above conditions.
                                </p>
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="overlayDisclaimer = false" block>
                                Close
                            </v-btn>
                        </v-card-actions>
                    </v-card>

                </v-overlay>
                <input type="file" ref="fileInput" style="display: none" accept="application/pdf"
                    @change="handleFileUpload" />
            </v-card>
        </v-container>
    </v-container>
</template>

<script>
import axios from 'axios';
import config from '../config.js';
import ProfileCircle from "./ProfileCircle.vue";
import { marked } from 'marked';
import * as XLSX from 'xlsx';

const DEFAULT_TYPING_TEXT = "Thinking";
const WEBSEARCH_TYPING_TEXT = "Websearch";
const PDF_TYPING_TEXT = "Analysing PDF";
const DEEPRESEARCH_TYPING_TEXT = "Deep Research. This might take a few minutes. Do not close.";
const SUMMARY_TYPING_TEXT = "Summarizing"
const PROGRESS_REFERENCESBOT = "Asking References Bot. This might take a minute. Do not close."
const PROGRESS_COMPANYCONTEXT = "Searching Company Context. This might take a minute. Do not close."

export default {
    components: {
        ProfileCircle,
    },
    props: {
        isMobile: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            input: '',
            messages: [],
            loading: true,
            isTyping: false,
            isPrintingText: true,
            drawer: false,
            selectedChatId: 0,
            chats: [
                //{ id: 0, title: 'Current Chat', started_at: new Date() },
            ],
            new_thread: true,
            username: '',
            email: '',
            showSnackbar: false,
            fileupload: false,
            fileprocessing: true,
            filename: '',
            selectedFile: undefined,
            filecontent: '',
            fileerror: false,
            fileerror_message: '',
            overlayDisclaimer: false,
            convertingPdfDone: false,
            modelMenu: false,
            models: 'Auto Reasoning (GPT-5.2)',
            pdf_dialog: false,
            promiseResolve: null,
            pdf_context: false,
            deepResearch: false,
            typingText: DEFAULT_TYPING_TEXT,
            has_flowcase_addon: false,
            use_flowcase_bot: false,
            thread_id: undefined,
            use_company_context_addon: false,
        };
    },
    mounted() {
        document.title = 'TIS Chat Bot'
        setTimeout(() => {
            this.loading = false;
            this.addMessage(`Hi ${this.username.split(' ')[0]}! How can I help you?`);
        }, 500);
    },
    beforeDestroy() {
        if (this.$refs.scrollContainer && this.$refs.scrollContainer.querySelectorAll('.exportButton')) {
            const buttons = this.$refs.scrollContainer.querySelectorAll('.exportButton');
            buttons.forEach(btn => {
                btn.removeEventListener('click', this.exportToExcel);
            });
        }
    },
    created() {
        this.getUser();
        //this.fetchChats();
    },
    methods: {
        toggleDeepResearch(e) {
            this.deepResearch = !this.deepResearch;
            if(this.deepResearch) {
                this.use_flowcase_bot = false;
                this.use_company_context_addon = false;
            }
        },
        toggleCompanyContextAddon(e) {
            this.use_company_context_addon = !this.use_company_context_addon;
            if(this.use_company_context_addon) {
                this.deepResearch = false;
                this.use_flowcase_bot = false;
            }
        },
        toggleReferenceBot(e) {
            this.use_flowcase_bot = !this.use_flowcase_bot;
            if(this.use_flowcase_bot) {
                this.deepResearch = false;
                this.use_company_context_addon = false;
            }
        },
        onRemoveFile(e) {
            this.fileupload = false
            this.filename = ''
            this.selectedFile = undefined;
            this.filecontent = ''
            this.fileprocessing = false
            this.fileerror_message = ''
            this.convertingPdfDone = false
        },
        onUploadFile(e) {
            const fileInput = this.$refs.fileInput;
            fileInput.click();
        },
        handleFileError(message) {
            this.selectedFile = undefined;
            this.filename = ''
            this.fileupload = false
            this.filecontent = ''
            this.fileprocessing = false
            this.fileerror_message = message
        },
        showPdfDialog() {
            this.pdf_dialog = true;
            return new Promise(resolve => {
                this.promiseResolve = resolve;
            });
        },
        pdfAnalysisNormal() {
            if (this.promiseResolve) {
                this.promiseResolve(false);
            }
            this.pdf_dialog = false;
        },
        pdfAnalysisDeep() {
            if (this.promiseResolve) {
                this.promiseResolve(true);
            }
            this.pdf_dialog = false;
        },
        async handleFileUpload(event) {
            this.fileprocessing = true
            const file = event.target.files[0];
            if (file) {
                if (file.type === 'application/pdf') {
                    this.selectedFile = file;
                    this.filename = file.name.slice(0, 15) + '…';
                    this.fileupload = true;
                    this.convertingPdfDone = true
                    this.fileprocessing = false
                }
            } else {
                this.selectedFile = undefined;
                this.handleFileError('Please provide a PDF file')
            }
        },
        stopTyping() {
            this.isPrintingText = false;
            this.isTyping = false;
        },
        renderMarkdown(text) {
            let html = marked(text);
            html = html.replace('<a', '<a target="_blank" rel="noopener noreferrer"')
            if (html.includes('<table')) {
                html = html.replace('<table', '<div class="tableDiv"><table class="exportTable"')
                html = html.replace(
                    '</table>',
                    '</table></div><div class="exportButtonDiv"><button class="exportButton"><span class="mdi mdi-microsoft-excel" style="font-size: 24px;"></span></button></div>'
                );
            }
            return html;
        },
        async getUser() {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Token not found in localStorage');
            }
            const headers = {
                Authorization: `Token ${token}`
            }

            const response = await axios.get(`${config.baseURL}/api/v1/user/me/`, { headers })
            if (response.status == 200) {
                const user_json = response.data
                this.username = user_json.first_name + ' ' + user_json.last_name
                this.email = user_json.email
            }

            const response_addons = await axios.get(`${config.baseURL}/api/v1/user/addons/`, { headers })
            if (response_addons.status == 200) {
                const addons_json = response_addons.data
                this.has_flowcase_addon = addons_json.has_flowcase_addon;
            }
        },
        async fetchChats() {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('Token not found in localStorage');
                }

                const response = await axios.get(`${config.baseURL}/api/v1/bot/chats`, {
                    headers: {
                        Authorization: `Token ${token}`
                    }
                });

                console.log(response)

                const chats = response.data.map(chat => ({
                    id: chat.id,
                    title: chat.title,
                    started_at: new Date(chat.started_at),
                    messages: []
                }));

                this.chats = chats;

                for (const chat of chats) {
                    try {
                        const chatId = chat.id;
                        const responseMessage = await axios.get(`${config.baseURL}/api/v1/bot/messages/?chat=${chatId}`, {
                            headers: {
                                Authorization: `Token ${token}`
                            }
                        });
                        chat.messages = responseMessage.data.map(item => ({
                            text: item.content,
                            from: item.from_user ? 'user' : 'bot'
                        }));

                    } catch (error) {
                        console.error(`Fehler beim Abrufen von Nachrichten für Chat mit ID ${chat.id}:`, error);
                    }
                }

                //this.chats = response.data;
            } catch (error) {
                console.error(error);
            }
        },
        addChat() {
            const firstChat = this.chats.find(chat => chat.title === 'Current Chat');
            if (firstChat) {
                firstChat.title = 'Unnamed chat';
            }
            const id = this.chats.length;
            const newChat = {
                id: id,
                title: 'Current Chat',
                started_at: new Date(),
            };

            this.selectedChatId = id;

            this.chats.unshift(newChat);
        },
        formatDate(date) {
            return date.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })
                + ', ' + date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
        },
        selectChat(id) {
            this.selectedChatId = id;
            console.log(this.chats)
            this.messages = this.chats[id - 1].messages;
            this.drawer = false;
        },
        chatScrollToBottom() {
            const container = this.$el.getElementsByClassName('bottom')[0];
            if (container) {
                container.scrollIntoView({ top: 0, behavior: 'smooth' });
            }
        },
        wait(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        async sendMessage() {
            if (this.input.trim() === '') return;

            while (this.fileupload && this.fileprocessing) {
                await this.wait(500);
            }

            if (this.fileupload) {
                this.messages.push({ text: `<div style="text-decoration: underline;"><span class="mdi mdi-file" style="font-size: 20px; margin-right: 5px"></span>${this.filename}</div>`, from: 'user' });
            }

            this.messages.push({ text: this.input, from: 'user' });

            const url = `${config.baseURL}/api/v1/bot/`;
            //const firstChat = this.chats.find(chat => chat.id === this.selectedChatId);

            let chat_id = this.selectedChatId;
            if (chat_id === 0) {
                for (const chat of this.chats) {
                    if (chat.id > chat_id) {
                        chat_id = chat.id;
                    }
                }
                chat_id += 1;
            }

            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Token not found in localStorage');
            }

            const headers = {
                headers: {
                    Authorization: `Token ${token}`
                }
            }

            const formData = new FormData();
            formData.append('user_message', this.input);
            formData.append('chat_id', chat_id);
            formData.append('email', this.email);
            formData.append('new_thread', this.new_thread);
            if (this.new_thread) {
                this.thread_id = crypto.randomUUID().replace(/-/g, '');
            }
            formData.append('thread_id', this.thread_id);
            formData.append('model_selection', this.models);
            formData.append('deepResearch', this.deepResearch);
            formData.append('use_flowcase_bot', this.use_flowcase_bot);
            formData.append('use_company_context_addon', this.use_company_context_addon);

            if (this.selectedFile != undefined) {
                formData.append('file', this.selectedFile);
                this.pdf_context = true;
            }

            formData.append('file_context', this.pdf_context);

            /*const data = {
                user_message: this.input,
                chat_id: chat_id,
                email: this.email,
                new_thread: this.new_thread,
                model_selection: this.models,
                //chat_title = data.get('chat_title') 
            };*/

            this.new_thread = false

            try {
                this.typingText = DEFAULT_TYPING_TEXT;
                this.isTyping = true;
                this.isPrintingText = true;
                this.chatScrollToBottom();
                this.input = '';
                this.onRemoveFile();

                //const response = await axios.post(url, formData, headers);
                const startRes = await axios.post(url, formData, headers);
                const taskId = startRes.data?.task_id;
                console.log(taskId)
                if (!taskId) throw new Error('No task_id returned from server');
                let delayMs = 1000;

                while (true) {
                    const statusUrl = `${url}?task_id=${encodeURIComponent(taskId)}`;
                    let statusRes;
                    try {
                        statusRes = await axios.get(statusUrl, headers);
                    } catch (e) {
                        console.error(e)
                        await this.wait(delayMs);
                    }

                    const { state, result, meta, error } = statusRes.data || {};

                    // Fortschritt (optional) anzeigen, wenn vorhanden
                    if (state && (state === 'PROGRESS' || state === 'STARTED' || state.startsWith?.('PROGRESS_'))) {
                        if (state === 'PROGRESS_WEBSEARCH') {
                            this.typingText = WEBSEARCH_TYPING_TEXT;
                        }
                        else if (state === 'PROGRESS_PDF') {
                            this.typingText = PDF_TYPING_TEXT;
                        }
                        else if (state === 'PROGRESS_DEEPRESEARCH') {
                            this.typingText = DEEPRESEARCH_TYPING_TEXT;
                        }
                        else if (state === 'PROGRESS_SUMMARY') {
                            this.typingText = SUMMARY_TYPING_TEXT;
                        }
                        else if (state === 'PROGRESS_REFERENCESBOT') {
                            this.typingText = PROGRESS_REFERENCESBOT;
                        }
                        else if (state === 'PROGRESS_COMPANYCONTEXT') {
                            this.typingText = PROGRESS_COMPANYCONTEXT;
                        }
                        else {
                            this.typingText = DEFAULT_TYPING_TEXT;
                        }

                        this.chatScrollToBottom();
                    }

                    // Bei SUCCESS: Ergebnis einsetzen & raus
                    if (statusRes.status === 200 && state === 'SUCCESS') {
                        const botText = result.result;
                        this.pdf_context = result.file_context;
                        console.debug(this.pdf_context)
                        this.addMessage(botText)
                        this.isTyping = false;
                        this.isPrintingText = false;
                        this.chatScrollToBottom();
                        //if (this.deepResearch && !Boolean(result.meta?.requires_action)) {
                            //this.toggleDeepResearch();
                        //}
                        return;
                    }

                    console.debug(state)

                    // Bei FAILURE: Fehlermeldung anzeigen & raus
                    if (state === 'FAILURE') {
                        this.addMessage('Unknown Error. Please try again.')
                        this.isTyping = false;
                        this.isPrintingText = false;
                        this.chatScrollToBottom();
                        return;
                    }

                    // Noch nicht fertig → 202 oder andere Zwischenstände
                    await this.wait(delayMs);
                    //delayMs = Math.min(delayMs * 1.2, maxDelayMs);
                }
            } catch (error) {
                this.addMessage('Unknown Error. Please try again...')
                //this.simulateTypingResponse('There was an error. Please try again...');
                console.error('Error:', error.response ? error.response.data : error.message);
            }
            this.typingText = DEFAULT_TYPING_TEXT;
        },
        exportToExcel(event) {
            const btn = event.target.closest('.exportButton');
            if (btn) {
                const exportSection = btn.closest('.message');
                if (exportSection) {
                    const table = exportSection.querySelector('.exportTable');
                    if (table) {
                        const workbook = XLSX.utils.table_to_book(table, { sheet: "Sheet1" });
                        XLSX.writeFile(workbook, 'DISlog_export.xlsx');
                    }
                }
            }
        },
        addMessage(message) {
            this.messages.push({ text: this.renderMarkdown(message), from: 'bot' });
            this.isTyping = false;
            this.isPrintingText = false;
        },
        close() {
            this.$router.push('/');
        },
        simulateTypingResponse(text) {
            let words = text.split(' ');
            let i = 0;
            const typingSpeed = 20;

            const addWord = () => {
                if (this.isPrintingText && i < words.length) {

                    const currentText = words.slice(0, i + 1).join(' ');

                    this.messages.push({ text: this.renderMarkdown(currentText), from: 'bot' });

                    if (i > 0) {
                        this.messages.splice(this.messages.length - 2, 1);
                    }

                    i++;
                    this.chatScrollToBottom();
                    setTimeout(addWord, typingSpeed);
                } else {
                    this.isTyping = false;
                    this.isPrintingText = false;
                }
            };

            setTimeout(addWord, typingSpeed);
        },
    },
    watch: {
        messages: {
            handler() {
                this.$nextTick(() => {
                    this.chatScrollToBottom();
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer.querySelectorAll('.exportButton')) {
                        const buttons = this.$refs.scrollContainer.querySelectorAll('.exportButton');
                        buttons.forEach(btn => {
                            btn.addEventListener('click', this.exportToExcel);
                        });
                    }
                });
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.typing-text {
    display: inline-block;
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0% {
        opacity: 0.25;
    }

    50% {
        opacity: 0.75;
    }

    100% {
        opacity: 0.25;
    }
}

.custom-chip {
    color: white;
}

.custom-chip .v-chip__close {
    color: white;
    opacity: 0.8;
}

.custom-chip .v-chip__close:hover {
    opacity: 1;
}

.chat-window {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 200px);
    width: 100%;
    max-width: 1400px;
    overflow: hidden;
    overflow-y: auto;
    max-height: calc(100vh - 200px);
}

.chat-window-mobile {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    max-height: calc(100vh - 150px);
}

.chat-content::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.chat-content::-webkit-scrollbar-thumb {
    background-color: #888;
    /* Farbe des Scrollbar-Griffs */
    border-radius: 4px;
    /* Abgerundete Ecken */
}

.chat-content::-webkit-scrollbar-thumb:hover {
    background-color: #555;
    /* Farbe des Griffs beim Hover */
}

.chat-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* Hintergrund der Scrollbar-Spur */
    border-radius: 4px;
}

/* Für Firefox */
.chat-content {
    scrollbar-width: thin;
    /* "thin" für schlanke Scrollbar */
    scrollbar-color: #888 #f1f1f1;
    /* Griff- und Hintergrundfarbe */
}

.chat-content {
    flex: 1;
    /* Füllt den verfügbaren Platz */
    overflow-y: auto;
    /* Scrollen bei Überlauf */
    padding: 16px;
    background-color: #fdfdfd;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.chat-actions {
    padding: 8px;
    background-color: #fff;
    border-top: 1px solid #ddd;
}

.chat-options {
    padding: 8px;
    background-color: #fff;
}

.message {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    text-align: left;
    font-family: Arial, sans-serif;
}

.avatar {
    margin-top: 10px;
    margin-left: 10px;
}

.bubble {
    padding: 10px 20px;
    border-radius: 20px;
    color: white;
    max-width: 80%;
    word-wrap: break-word;
    overflow-x: hidden;
}

::v-deep(.a) {
    color: black;
}

::v-deep(.bubble .exportButtonDiv) {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep(.bubble .exportButton) {
    font-size: 11px;
    color: #e9e9e9;
    background: none;
    border: none;
    cursor: pointer;
    margin-top: 5px;
}

::v-deep(.bubble .tableDiv) {
    overflow-x: auto;
}

::v-deep(.bubble table) {
    width: 100%;
    max-width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
    box-sizing: border-box;
    font-size: small;
}

::v-deep(.bubble th),
::v-deep(.bubble td) {
    border: 1px solid #dddddd;
    padding: 12px 15px;
    text-align: left;
}

/* Hintergrundfarbe und Schriftfarbe für Tabellenkopf */
::v-deep(.bubble th) {
    background-color: #005c7e;
    color: #ffffff;
}

::v-deep(.bubble h1) {
    font-size: 2em;
    font-weight: bold;
    margin: 0.67em 0;
}

::v-deep(.bubble h2) {
    font-size: 1.5em;
    font-weight: bold;
    margin: 0.75em 0;
}

::v-deep(.bubble h3) {
    font-size: 1.2em;
    font-weight: bold;
    margin: 0.85em 0;
}

::v-deep(.bubble p) {
    font-size: 1em;
    line-height: 1.6;
    margin: 0.5em 0;
}

::v-deep(.bubble ul) {
    list-style-type: disc;
    margin-left: 1.5em;
}

::v-deep(.bubble ol) {
    list-style-type: decimal;
    margin-left: 1.5em;
}

::v-deep(.bubble li) {
    margin: 0.3em 0;
}

::v-deep(.bubble a) {
    color: #3d3d3d;
    text-decoration: none;
}

::v-deep(.bubble blockquote) {
    margin: 1em 0;
    padding: 0.5em 1em;
    border-left: 4px solid #ccc;
    color: #555;
    background-color: #f9f9f9;
}

::v-deep(.bubble pre) {
    background-color: #f4f4f4;
    padding: 1em;
    overflow-x: auto;
    border-radius: 5px;
}

::v-deep(.bubble code) {
    background-color: #f9f2f4;
    color: #c7254e;
    padding: 0.2em 0.4em;
    border-radius: 3px;
    font-family: monospace;
}

::v-deep(.bubble img) {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 1em 0;
}

::v-deep(.bubble hr) {
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
}

.bot {
    background-color: #ffffff;
    color: black !important;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
    font-weight: 400;
    font-size: medium;
}

.is-disabled { opacity: .5; pointer-events: none; }

.user {
    background-color: #adadad;
}

.input-field {
    width: 100%;
}

.typing-animation {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 30px;
    margin-left: 10px;
}

.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 3px;
    opacity: 0.4;
    animation: typing 1s infinite;
}

@keyframes typing {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-5px);
    }
}
</style>